var WaltCache = new (function () {
  this.cache = {};
  this.flips = {};

  this.set = (beam, walts) => {
    this.cache[beam] = walts;
  };

  this.get = beam => {
    if (this.cache[beam]) {
      return this.cache[beam];
    }
    return null;
  };

  this.getFlips = beam => {
    if (this.flips[beam]) {
      return this.flips[beam];
    }
    return null;
  };

  this.record_flips = (beam, flips) => {
    this.flips[beam] = flips;
  };
})();
export default WaltCache;
